'use strict';

angular.module('amexReconciliationApp')
  .directive('flashMessage',
  function flashMessage() {
    var controller = function ($scope, FlashService) {
      $scope.displayFlashMessage = (!!FlashService.message);
      $scope.$on('$stateChangeSuccess', function () {
        FlashService.message = undefined;
      });
    };

    return {
      restrict: 'E',
      templateUrl: 'scripts/views/directives/flash-message.html',
      controller: controller
    };
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/directives/flashMessage.js
// module id = 522
// module chunks = 0